import { closablePopoverDriverFactory } from './ClosablePopover/ClosablePopover.driver';
import { dataHooks } from './constants';
import { floatingHelperContentDriverFactory } from './FloatingHelperContent/FloatingHelperContent.driver';
import { deprecationTestkitLog } from '../utils/deprecationTestkitLog';

const floatingHelperDriverFactory = ({ wrapper, element, eventTrigger }) => {
  deprecationTestkitLog(
    'floatingHelperTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the FloatingHelperTestkit unidriver testkit instead.',
  );

  const closablePopoverDriver = closablePopoverDriverFactory({
    wrapper,
    element,
    eventTrigger,
  });
  const popoverContent = () => closablePopoverDriver.getContentElement();
  const innerContent = () =>
    popoverContent().querySelector(`[data-hook='${dataHooks.innerContent}']`);
  const closeButton = () =>
    popoverContent().querySelector(`[data-hook='${dataHooks.closeButton}']`);
  const contentWrapper = () =>
    popoverContent().querySelector(`[data-hook='${dataHooks.contentWrapper}']`);

  return {
    ...closablePopoverDriver,
    /** check whether the helper has a close button */
    hasCloseButton: () => !!closeButton(),
    /** click the close button */
    clickCloseButton: () => eventTrigger.click(closeButton()),
    helperContent: floatingHelperContentDriverFactory({
      wrapper,
      element: innerContent(),
      eventTrigger,
    }),
    /** Get the driver for the helper's content */
    getHelperContentDriver: () =>
      floatingHelperContentDriverFactory({
        wrapper,
        element: innerContent(),
        eventTrigger,
      }),
    /** Get width of content's root element */
    getWidth: () => window.getComputedStyle(contentWrapper()).width,
  };
};

export { floatingHelperDriverFactory };
